
import { reatiler } from "../../../../../../core/utils/report-datas";
import { useEffect, useState } from "react";
import SalesAmountByProductGroup from "./sales-amount-by-product-group/sales-amount-by-product-group";
import TopTenProducts from "./top-ten-products/top-ten-products";
import SalesAmountTrend from "./sales-amount-trend/sales-amount-trend";
import SalesQuantityTrend from "./sales-quantity-trend/sales-quantity-trend";
import AvgSalesPriceByCity from "./avg-sales-price-by-city/avg-sales-price-by-city";
import TotalSalesByMarket from "./total-sales-by-market/total-sales-by-market";
// import ResponsiveBox, {
//     Row,
//     Col,
//     Item,
//     Location,
// } from 'devextreme-react/responsive-box';
import { Col, Form, Row } from "react-bootstrap";
import { DateBox, TagBox } from "devextreme-react";
import { extFormatDate } from "@/core/helper/date-helper";



export default function DashBoard() {

    const [startDate, setStartDate] = useState<Date>(new Date(2024, 0, 1))
    const [endDate, setEndDate] = useState<Date>(new Date())
    const [retailer, setDetailer] = useState();
    const [initStartDate, setInitStartDate] = useState<string>(extFormatDate(startDate));
    const [initEndDate, setInitEndDate] = useState<string>(extFormatDate(endDate));

    function onRetailerValueChanged(e: any) {
        const retailerIds = e.value.join('%2C');
        setDetailer(retailerIds);
    }
    function onStartDateValueChanged(e: any) {
        setInitStartDate(extFormatDate(e.value))
    }
    function onEndDateValueChanged(e: any) {
        setInitEndDate(extFormatDate(e.value))
    }
    return (
        <>
            <div className='view-wrapper'>
                <Row>
                    <h5 className="text-center">Dashboard</h5>
                </Row>
                <br></br>
                <Row>
                    <Col md={1}></Col>
                    <Col md={4}>
                        <Form.Label htmlFor="retailers">Retailers</Form.Label>
                        <TagBox
                            items={reatiler}
                            showSelectionControls={true}
                            maxDisplayedTags={2}
                            displayExpr="Text"
                            valueExpr="Value"
                            onValueChanged={onRetailerValueChanged} />

                    </Col>
                    <Col md={3}>
                        <Form.Label htmlFor="startDate">Start Date</Form.Label>
                        <DateBox
                            value={startDate}
                            name='startDate'
                            type="date"
                            onValueChanged={onStartDateValueChanged}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Label htmlFor="endDate">End Date</Form.Label>
                        <DateBox
                            value={endDate}
                            name='endDate'
                            type="date"
                            onValueChanged={onEndDateValueChanged}
                        />
                    </Col>
                    <Col md={1}> </Col>
                </Row>
                <br></br>
                <Row>
                    <Col md={4}>
                        <div className={'card'}>
                            <TotalSalesByMarket
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                            >
                            </TotalSalesByMarket>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className={'card'}>
                            <SalesQuantityTrend
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                            >
                            </SalesQuantityTrend>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className={'card'}>
                            <SalesAmountByProductGroup
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                            ></SalesAmountByProductGroup>
                        </div>
                    </Col>
                </Row >
                <br></br>
                <Row>

                    <Col>
                        <div className={'card'}>
                            <SalesAmountTrend
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                            >
                            </SalesAmountTrend>
                        </div>
                    </Col>
                </Row>
                <br></br>
                <Row>
                    <Col md={6}>
                        <div className={'card'}>
                            <TopTenProducts
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                                >
                            </TopTenProducts>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className={'card'}>
                            <AvgSalesPriceByCity
                                retailerId={retailer}
                                startDate={initStartDate}
                                endDate={initEndDate}
                            >
                            </AvgSalesPriceByCity>
                        </div>
                    </Col>
                </Row>

            </div>
        </>
    );
}

